import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';
import styles from './DateTimeField.module.css';

const pad = (n) => String(n).padStart(2, '0');

/** Date → 'YYYY-MM-DDTHH:mm' no fuso LOCAL (toISOString deslocaria a hora). */
export const toLocalInput = (d) => {
  const x = new Date(d);
  return `${x.getFullYear()}-${pad(x.getMonth() + 1)}-${pad(x.getDate())}T${pad(x.getHours())}:${pad(x.getMinutes())}`;
};

// Presets prontos pros forms (label vem do chamador via i18n).
export const presetNow = () => new Date();
export const presetPlusDays = (days, { endOfDay = false } = {}) => () => {
  const d = new Date();
  d.setDate(d.getDate() + days);
  if (endOfDay) d.setHours(23, 59, 0, 0);
  return d;
};
export const presetEndOfMonth = () => {
  const d = new Date();
  return new Date(d.getFullYear(), d.getMonth() + 1, 0, 23, 59);
};

/**
 * Campo de data+hora amigável: inputs nativos separados (pickers melhores que
 * o datetime-local), atalhos rápidos e limpar. `value` no formato
 * 'YYYY-MM-DDTHH:mm' local ('' = vazio).
 *
 * @param {{ label?, value, onChange, presets?: {label, value: () => Date}[],
 *           clearable?: boolean, defaultTime?: string }} props
 */
export default function DateTimeField({
  label,
  value = '',
  onChange,
  presets = [],
  clearable = false,
  defaultTime = '00:00',
}) {
  const { t } = useTranslation();
  const [date = '', time = ''] = value ? value.split('T') : [];

  const emit = (d, tm) => onChange(d ? `${d}T${tm || defaultTime}` : '');

  return (
    <div className={styles.wrap}>
      {label && <span className={styles.label}>{label}</span>}
      <div className={styles.row}>
        <input
          type="date"
          className={styles.input}
          value={date}
          onChange={(e) => emit(e.target.value, time)}
          aria-label={t('datetime.date')}
        />
        <input
          type="time"
          className={`${styles.input} ${styles.time}`}
          value={time}
          onChange={(e) => emit(date, e.target.value)}
          disabled={!date}
          aria-label={t('datetime.time')}
        />
        {clearable && value && (
          <button type="button" className={styles.clear} onClick={() => onChange('')} aria-label={t('datetime.clear')}>
            <X size={14} strokeWidth={2} />
          </button>
        )}
      </div>
      {presets.length > 0 && (
        <div className={styles.presets}>
          {presets.map((p) => (
            <button
              key={p.label}
              type="button"
              className={styles.preset}
              onClick={() => onChange(toLocalInput(p.value()))}
            >
              {p.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
